import axios from 'axios'
export const getAwardLevels = async (organizationId, programId, params="") => {
  try {
    let url = `/organization/${organizationId}/program/${programId}/program-award-levels`
    if( params != "" ) {
      url += `?${params}`
    }
    const response = await axios.get(url)
    return response.data
  } catch (e) {
    throw new Error(`API error:${e?.message}`);
  }
}

export default getAwardLevels